import worker from "workerize-loader?name=notificationWorker.[hash]!./notificationWorker";// eslint-disable-line import/no-webpack-loader-syntax

const notificationWorker = worker();
export default notificationWorker;

/**
 * @author Aston Kingsley
 * here we create a worker instance for the notification worker
 */